import { CommonModule } from "@angular/common";
import { Component, inject, Inject, EventEmitter, Output } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddCollaboratorDTO } from "@models/collaborator";
import {
  PdvAccessFieldsComponent,
  pdvAccessControls,
  pdvAccessPayload,
} from "../pdv-access-fields.component";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { DdiSelectComponent } from "../../../../../shared/components/ddi-select/ddi-select.component";

import { phoneNumberValidator } from "@shared/validatos";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { DialogHeaderComponent } from "../../../../../shared/components/dialog-header/dialog-header.component";
import { LoadingComponent } from "../../../../../shared/components/loading/loading.component";

export interface AddEmployeeDialogData {
  eventId: number;
  operatorsOnly?: boolean;
}

@Component({
  selector: "app-add-employee-dialog",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DdiSelectComponent,
    NgxMaskDirective,
    LoadingComponent,
    MatDialogModule,
    DialogHeaderComponent,
    ButtonComponent,
    PdvAccessFieldsComponent,
  ],
  providers: [provideNgxMask()],
  templateUrl: "./add-employee-dialog.component.html",
  styleUrls: [
    "./add-employee-dialog.component.scss",
    "../collaborator-dialog.scss",
  ],
})
export class AddEmployeeDialogComponent {
  private readonly _fb = inject(FormBuilder);
  readonly dialogRef = inject(MatDialogRef<AddEmployeeDialogComponent>);

  eventId: number;
  loading = false;
  apiError = "";
  @Output() submitted = new EventEmitter<AddCollaboratorDTO>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: AddEmployeeDialogData) {
    this.eventId = data.eventId;
    if (data.operatorsOnly) this.form.controls.role.setValue("pdv_portaria");
  }

  form = this._fb.group({
    email: ["", [Validators.required, Validators.email]],
    phone: ["", [Validators.required, phoneNumberValidator]],
    ddi: ["+55", Validators.required],
    ...pdvAccessControls(),
  });

  controls = this.form.controls;

  confirm() {
    if (this.loading) return;
    if (this.data.operatorsOnly && this.controls.role.value !== "pdv_portaria")
      return;
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    const { phone, ddi, email } = this.form.getRawValue();
    if (!email || !phone || !ddi) return;
    const newEmployee: AddCollaboratorDTO = {
      collaborator: {
        user_phone_number: `${ddi}${phone}`,
        email,
        ...pdvAccessPayload(this.controls),
      },
    };
    this.submitted.emit(newEmployee);
  }
}
